import CannotViewField from "./CannotViewField";
import React from "react";
import { TextContentInput } from "../../component/input";
import { required } from "react-admin";
import usePrivileges from "../usePrivileges";

const ResultsImpactField = (props) => {
  const { canView } = usePrivileges({ ...props });
  if (!canView) {
    return <CannotViewField {...props} fullWidth />;
  }
  return (
    <TextContentInput
      {...props}
      minLength={1000}
      maxLength={6000}
      multiline
      validate={[required()]}
    />
  );
};
export default ResultsImpactField;
